import React, { useMemo } from 'react';
import { FormControl, Box, FormLabel, FormHelperText, Select, Flex, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import c from '../../constant';
import useStore from '../../store';

const MonthRangeFormField = ({ disabled = false, name = null, label = null, required = false }) => {
	const { t } = useTranslation('common');
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const months = useMemo(
		() => [
			{ label: lang === 'kh' ? 'មករា' : 'January', value: '0' },
			{ label: lang === 'kh' ? 'កុម្ភៈ' : 'February', value: '1' },
			{ label: lang === 'kh' ? 'មីនា' : 'March', value: '2' },
			{ label: lang === 'kh' ? 'មេសា' : 'April', value: '3' },
			{ label: lang === 'kh' ? 'ឧសភា' : 'May', value: '4' },
			{ label: lang === 'kh' ? 'មិថុនា' : 'June', value: '5' },
			{ label: lang === 'kh' ? 'កក្កដា' : 'July', value: '6' },
			{ label: lang === 'kh' ? 'សីហា' : 'August', value: '7' },
			{ label: lang === 'kh' ? 'កញ្ញា' : 'September', value: '8' },
			{ label: lang === 'kh' ? 'តុលា' : 'October', value: '9' },
			{ label: lang === 'kh' ? 'វិច្ឆិកា' : 'November', value: '10' },
			{ label: lang === 'kh' ? 'ធ្នូ' : 'December', value: '11' },
		],
		[lang],
	);

	return (
		<Field name={name}>
			{({ field, meta, form }) => {
				return (
					<Box mb="4" overflow="hidden">
						<FormControl id={name}>
							{label && (
								<FormLabel>
									{t(label)}
									{required && <span style={{ color: 'red' }}>*</span>}
								</FormLabel>
							)}
							<Flex justifyContent="flex-start" alignItems="center">
								<Select
									h={12}
									value={field?.value?.from || ''}
									onChange={(e) => form.setFieldValue(name, { ...field?.value, from: e.target.value })}
									placeholder={t('From')}
									borderRadius={c.borderRadius}
									disabled={disabled}
								>
									{months?.map((month, index) => {
										return (
											<option key={`option-item-${index}`} value={month?.value}>
												{t(month?.label)}
											</option>
										);
									})}
								</Select>
								<Text mx={2}>-</Text>
								<Select
									h={12}
									value={field?.value?.to || ''}
									onChange={(e) => form.setFieldValue(name, { ...field?.value, to: e.target.value })}
									placeholder={t('To')}
									borderRadius={c.borderRadius}
									disabled={disabled}
								>
									{months?.map((month, index) => {
										return (
											<option key={`option-item-${index}`} value={month?.value}>
												{t(month?.label)}
											</option>
										);
									})}
								</Select>
							</Flex>
							{meta.touched && meta.error && (
								<FormHelperText id="error-message-password" color="red.400" fontSize="12px">
									{t(meta.error)}
								</FormHelperText>
							)}
						</FormControl>
					</Box>
				);
			}}
		</Field>
	);
};

export default MonthRangeFormField;
